enum OverflowEnum {
    Ellipsis = 'ellipsis',
}

export default OverflowEnum
